import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { IRetailerLaunchWithFaire as IOpenWithFaire } from "@faire/web-api--source/indigofair/data/IRetailerLaunchWithFaire";
export var useOpenWithFaireApplicationStatus = function() {
    var retailer = useRetailer().retailer;
    var launchWithFaire = retailer === null || retailer === void 0 ? void 0 : retailer.launch_with_faire;
    var status = launchWithFaire === null || launchWithFaire === void 0 ? void 0 : launchWithFaire.status;
    var isEligible = status === IOpenWithFaire.Status.ELIGIBLE;
    var hasApplicationInProgress = status === IOpenWithFaire.Status.APPLICATION_IN_PROGRESS;
    var isOnHold = status === IOpenWithFaire.Status.ON_HOLD || status === IOpenWithFaire.Status.ON_HOLD_NO_LEASE;
    var isNotEligibleForOwF = status === undefined || status === IOpenWithFaire.Status.NOT_ELIGIBLE;
    var showOwFR2RCopyToNotEligible = isNotEligibleForOwF && getGlobalProperty("owfReferralCodeV2") !== undefined;
    return {
        status: status,
        isOnHold: isOnHold,
        isEligible: isEligible,
        isNotEligibleForOwF: isNotEligibleForOwF,
        showOwFR2RCopyToNotEligible: showOwFR2RCopyToNotEligible,
        applicationType: launchWithFaire === null || launchWithFaire === void 0 ? void 0 : launchWithFaire.application_type,
        appliedAt: launchWithFaire === null || launchWithFaire === void 0 ? void 0 : launchWithFaire.applied_at,
        canApply: isEligible || hasApplicationInProgress,
        hasPendingOwfUwRequest: !!(launchWithFaire === null || launchWithFaire === void 0 ? void 0 : launchWithFaire.has_pending_owf_uw_request),
        hasApplicationInProgress: hasApplicationInProgress,
        hasApplicationPendingReview: status === IOpenWithFaire.Status.APPLIED,
        hasApplied: status === IOpenWithFaire.Status.APPLIED || isOnHold,
        isAccepted: status === IOpenWithFaire.Status.ACCEPTED,
        isOwFExpired: status === IOpenWithFaire.Status.EXPIRED,
        isRejectedForOwF: status === IOpenWithFaire.Status.REJECTED
    };
};
